import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiPopupMenuItemComponent } from '@ui/modules/ui-popup-menu-item/ui-popup-menu-item.component';
import {
  LucideAngularModule,
  ArrowLeft,
  Trash2,
  Pencil,
  Lock,
  Unlink,
  Users,
  Star,
  ArchiveRestore,
  UserX,
  ChartColumn,
  ListChecks,
  GraduationCap,
  Eye,
  Link,
  Mail,
  X,
  FileText,
} from 'lucide-angular';

@NgModule({
  declarations: [
    UiPopupMenuItemComponent
  ],
  exports: [
    UiPopupMenuItemComponent
  ],
  imports: [
    CommonModule,
    LucideAngularModule.pick({
      ArrowLeft,
      Trash2,
      Pencil,
      Lock,
      Unlink,
      Users,
      Star,
      ArchiveRestore,
      UserX,
      ChartColumn,
      ListChecks,
      GraduationCap,
      Eye,
      Link,
      Mail,
      X,
      FileText,
    }),
  ]
})
export class UiPopupMenuItemModule { }
